import { TutorialId } from "@repo/api/tutorial";

export type Tutorial = {
  id: TutorialId;
  title: string;
  kind: "Tutorial" | "Tip";
  minutes: number;
  vimeoId: string;
  thumbnailSrc: string;
};

export const TUTORIALS: Tutorial[] = [
  {
    id: "WELCOME",
    title: "Welcome to Amplifiles",
    kind: "Tutorial",
    minutes: 2,
    vimeoId: "1241658665",
    thumbnailSrc: "/home/tutorials/welcome.jpg",
  },
  {
    id: "HOW_CREDITS_WORK",
    title: "How credits work",
    kind: "Tutorial",
    minutes: 3,
    vimeoId: "1241658664",
    thumbnailSrc: "/home/tutorials/how-credits-work.jpg",
  },
  {
    id: "CAMERA_MOVEMENTS",
    title: "Camera movements",
    kind: "Tutorial",
    minutes: 3,
    vimeoId: "1241658451",
    thumbnailSrc: "/home/tutorials/camera-movements.jpg",
  },
  {
    id: "CLIP_LENGTH_AND_ORDER",
    title: "Clip length & order",
    kind: "Tutorial",
    minutes: 1,
    vimeoId: "1241658449",
    thumbnailSrc: "/home/tutorials/clip-length-and-order.jpg",
  },
  {
    id: "FINE_TUNE_CLIPS",
    title: "Fine-tune clips",
    kind: "Tutorial",
    minutes: 2,
    vimeoId: "1241658448",
    thumbnailSrc: "/home/tutorials/fine-tune-clips.jpg",
  },
  {
    id: "TRANSITIONS",
    title: "Transitions",
    kind: "Tutorial",
    minutes: 3,
    vimeoId: "1241658447",
    thumbnailSrc: "/home/tutorials/transitions.jpg",
  },
];

export function formatTutorialMeta(tutorial: Tutorial) {
  return `${tutorial.kind} · ${tutorial.minutes} min`;
}

const INTRO_TUTORIAL_IDS: TutorialId[] = ["WELCOME", "HOW_CREDITS_WORK"];

export function getTutorialOrder({
  hasCreatedContent,
  openedTutorialIds,
}: {
  hasCreatedContent: boolean;
  openedTutorialIds: TutorialId[];
}) {
  const path = hasCreatedContent
    ? [
        ...TUTORIALS.filter(
          (tutorial) => !INTRO_TUTORIAL_IDS.includes(tutorial.id),
        ),
        ...TUTORIALS.filter((tutorial) => tutorial.id === "HOW_CREDITS_WORK"),
      ]
    : TUTORIALS;
  const isOpened = (tutorial: Tutorial) =>
    openedTutorialIds.includes(tutorial.id);
  const opened = path.filter(isOpened);

  // An opened Welcome goes last so it's never suggested again.
  return [
    ...path.filter((tutorial) => !isOpened(tutorial)),
    ...opened.filter((tutorial) => tutorial.id !== "WELCOME"),
    ...opened.filter((tutorial) => tutorial.id === "WELCOME"),
  ];
}
